import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface ReportsLimitationBannerProps {
  isLimited: boolean;
}

export function ReportsLimitationBanner({ isLimited }: ReportsLimitationBannerProps) {
  const { t } = useTranslation("common");

  if (!isLimited) return null;

  return (
    <Alert className="mb-4 border-amber-200 bg-amber-50 relative">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertTitle className="text-amber-800 pr-8">
        {t("premium.banners.limitedReports.title")}
      </AlertTitle>
      <AlertDescription className="text-amber-700">
        {t("premium.banners.limitedReports.description")}
      </AlertDescription>
    </Alert>
  );
}
